/**
 * Full-document navigations for the payment page boundary.
 *
 * The payment page boots in its own minimal tree (see main.jsx), which only
 * a real document load can produce — a client-side route change would keep
 * the full app, its telemetry and its default-axios interceptors alive.
 * Kept in one module so tests can replace it.
 */

/** Go to the payment page link issued by the API (`…/pay#t=…`). */
export function goToPayPage(url) {
  window.location.assign(url);
}

/** Load this document again, so main.jsx decides the tree from scratch. */
export function reloadDocument() {
  window.location.reload();
}

/**
 * Is this a link we are willing to navigate to? An http(s) URL whose path
 * is the payment page. Anything else is refused.
 */
export function isPayPageUrl(url) {
  if (typeof url !== 'string' || !url) return false;
  try {
    const parsed = new URL(url, window.location.origin);
    return (parsed.protocol === 'https:' || parsed.protocol === 'http:') && /^\/pay\/?$/.test(parsed.pathname);
  } catch {
    return false;
  }
}
